<svg:g transform="translate(-3, 20)">
    <path
        d="M47.4308 51.86L139.295 98.5402L139.736 125.966L47.8573 79.2635L47.4308 51.86Z"
        [attr.fill]="'var(--wall-bg-1)'"
        stroke="url(#paint1_linear_7217_69598)" />
    <path
        d="M235.825 47.8033L139.788 97.6686L48.0119 51.0334L144.04 1.13494L235.825 47.8033Z"
        [attr.fill]="'var(--roof-bg)'"
        stroke="url(#paint2_linear_7217_69598)" />
    <path
        d="M236.869 76.0027L140.736 125.971L140.295 98.532L236.432 48.6151L236.869 76.0027Z"
        [attr.fill]="'var(--wall-bg-2)'"
        stroke="url(#paint3_linear_7217_69598)" />
    <path class="helipad-circle"
        d="M175.348 33.2472C182.306 37.159 186.753 42.3546 187.258 48.0968C187.286 48.3544 186.671 48.8361 185.811 48.8652C184.964 48.8877 174.826 48.8652 173.916 48.8652C173.479 48.8652 173.13 48.7555 172.889 48.6367C172.629 48.4978 172.502 48.332 172.491 48.211C172.071 44.53 169.181 41.1918 164.71 38.6803C164.433 38.519 164.329 37.8827 164.812 37.6586C165.293 37.4346 172.014 33.7581 172.879 33.3458C173.745 32.9448 174.969 33.0411 175.348 33.2472Z" />
    <path class="helipad-circle"
        d="M186.716 50.6082C187.119 50.8278 187.353 51.2176 187.331 51.4416C186.931 57.0494 182.778 62.1262 176.173 66.0134C175.825 66.215 174.72 66.3584 174.122 66.094C173.955 66.0134 173.223 65.637 172.263 65.1194C171.293 64.6041 170.101 63.9544 168.981 63.3697C167.407 62.5273 165.996 61.77 165.698 61.6221C165.011 61.2592 165.377 60.6453 165.719 60.428C169.75 57.9322 172.274 54.7261 172.586 51.2064C172.597 50.9712 173.212 50.4536 174.165 50.4491C177.094 50.4088 183.389 50.4088 186.088 50.4536C186.333 50.4536 186.532 50.5119 186.716 50.6082Z"
         />
    <path class="helipad-circle"
        d="M168.843 65.8254C170.351 66.623 171.61 67.2929 171.82 67.4139C172.381 67.7477 172.047 68.2854 171.688 68.4691C164.361 72.2196 154.579 74.59 143.726 74.8476C143.444 74.8476 142.994 74.7961 142.673 74.6348C142.463 74.5205 142.325 74.3704 142.329 74.1419C142.346 73.5862 142.247 68.3481 142.279 67.8552C142.329 67.3579 143.267 66.9904 143.761 66.9725C150.469 66.7081 156.526 65.2407 161.145 62.9465C161.534 62.7448 162.594 62.5163 163.252 62.8658C163.657 63.0787 166.536 64.5977 168.843 65.8254Z"
         />
    <path class="helipad-circle"
        d="M139.385 67.4473C139.602 67.5526 139.74 67.696 139.701 67.8259C139.595 68.2225 139.779 73.5502 139.74 74.0386C139.719 74.5136 138.209 74.899 137.721 74.8878C127.224 74.704 117.675 72.5196 110.332 69.038L110.271 68.991C109.794 68.7512 109.272 68.1262 109.976 67.7475C110.737 67.3398 117.242 63.8357 118.039 63.428C118.86 63.0269 120.242 63.2263 120.736 63.4571C125.415 65.5564 131.355 66.8693 137.864 67.0239C138.159 67.0306 138.937 67.2009 139.385 67.4473Z"
         />
    <path class="helipad-circle"
        d="M107.442 51.1147C107.875 51.3365 108.114 51.6367 108.153 51.8182C108.714 55.2326 111.38 58.3288 115.451 60.7149C115.895 60.9837 116.326 61.7701 115.721 62.104C115.123 62.4176 108.551 65.9239 107.786 66.3473C107.022 66.7551 105.601 66.5826 105.159 66.3473C98.4869 62.5677 94.1502 57.6298 93.4072 52.1632C93.3465 51.7039 94.005 50.7293 95.3308 50.7808C96.6565 50.8436 104.68 50.7808 106.017 50.7764C106.621 50.7764 107.093 50.9242 107.442 51.1147Z"
         />
    <path class="helipad-circle"
        d="M137.838 25.1254C138.193 25.3203 138.453 25.6071 138.419 26.044C138.354 27.0006 138.319 31.132 138.471 31.784C138.609 32.4606 137.411 32.6443 136.878 32.6734C130.341 32.9086 124.395 34.3201 119.798 36.5225C119.321 36.751 118.201 37.1251 117.097 36.5628C116.559 36.2939 114.902 35.4157 113.239 34.5442C111.579 33.6614 109.933 32.7765 109.443 32.4964C108.44 31.9341 109.073 31.0805 109.656 30.787C116.787 27.3121 126.08 25.1142 136.356 24.805C136.733 24.7983 137.366 24.8902 137.838 25.1254Z"
         />
    <path class="helipad-circle"
        d="M110.349 35.4718C112.318 36.5226 114.402 37.6585 114.79 37.9094C115.489 38.3239 115.262 38.9601 114.907 39.1954C110.919 41.6509 108.373 44.7875 108.02 48.2691C107.986 48.5604 107.604 49.4207 106.222 49.405C104.836 49.3871 96.4636 49.4453 95.0534 49.3983C94.5227 49.3938 94.1436 49.2773 93.8663 49.1339C93.3898 48.8875 93.2403 48.5268 93.2468 48.361C93.5739 42.7465 97.6659 37.6517 104.227 33.7355C104.665 33.489 105.657 33.1619 106.822 33.666C107.327 33.8945 108.802 34.6518 110.349 35.4718Z"
         />
    <path class="helipad-circle"
        d="M170.517 30.7467C171.659 31.383 170.816 31.8759 170.76 31.9117C170.39 32.1066 163.163 35.9826 162.466 36.3455C161.749 36.7062 160.536 36.5001 160.109 36.3052C155.467 34.1813 149.572 32.8236 143.089 32.6331C142.74 32.6219 142.162 32.4965 141.785 32.2836C141.547 32.1694 141.375 32.0081 141.369 31.8311C141.319 30.386 141.304 27.3054 141.33 25.7349C141.343 25.1322 142.552 24.7468 143.117 24.7648C153.647 24.9821 162.754 27.1105 170.517 30.7467Z"
         />
    <defs>
        <linearGradient
            id="paint1_linear_7217_69598"
            x1="93.5836"
            y1="51.0386"
            x2="93.5836"
            y2="126.787"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1D53A4"
                stop-opacity="0.33" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_7217_69598"
            x1="141.918"
            y1="0.572754"
            x2="141.918"
            y2="98.2307"
            gradientUnits="userSpaceOnUse">
            <stop
                stop-color="#1D53A4"
                stop-opacity="0.2" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint3_linear_7217_69598"
            x1="188.582"
            y1="47.7988"
            x2="188.582"
            y2="126.787"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1D53A4"
                stop-opacity="0.33" />
        </linearGradient>
        <linearGradient
            id="paint4_linear_7217_69598"
            x1="70"
            y1="82.5"
            x2="70"
            y2="814"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1D53A4"
                stop-opacity="0.33" />
        </linearGradient>
    </defs>
</svg:g>
